import { render } from "./personrecordinfo.vue?vue&type=template&id=f592e4a2&scoped=true&ts=true"
import script from "./personrecordinfo.vue?vue&type=script&lang=ts"
export * from "./personrecordinfo.vue?vue&type=script&lang=ts"

import "./personrecordinfo.vue?vue&type=style&index=0&id=f592e4a2&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f592e4a2"]])

export default __exports__